// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterSection_wrapper__ivpKp","heading":"FilterSection_heading__9jzpH","progressBar":"FilterSection_progressBar__ebSRp","cardsWrapper":"FilterSection_cardsWrapper__PFNzy"};